import { useLingui } from '@lingui/react/macro';
import type { FC } from 'react';
import { Digits } from '@/shared/Digits';
import bearishIcon from '../../assets/Bearish.svg';
import bullishIcon from '../../assets/Bullish.svg';

type VoteProgressBarProps = {
  bullishPercent: number;
  bearishPercent: number;
};

export const VoteProgressBar: FC<VoteProgressBarProps> = ({
  bullishPercent,
  bearishPercent,
}) => {
  const { t } = useLingui();

  return (
    <div className="w-sm max-w-full flex flex-col gap-2">
      <div className="w-full overflow-hidden rounded-full bg-border-disabled relative h-3">
        <div
          className="h-full bg-background-positive transition-all duration-300 ease-in-out absolute left-0 top-0"
          style={{
            width: `${bullishPercent}%`,
            clipPath:
              bullishPercent > 0 && bullishPercent < 100
                ? 'polygon(0 0, 100% 0, calc(100% - 8px) 100%, 0 100%)'
                : undefined,
          }}
        />
        <div
          className="h-full bg-background-negative transition-all duration-300 ease-in-out absolute top-0"
          style={{
            left: `${bullishPercent}%`,
            width: `${bearishPercent}%`,
            clipPath:
              bearishPercent > 0 && bearishPercent < 100 && bullishPercent > 0
                ? 'polygon(8px 0, 100% 0, 100% 100%, 0 100%)'
                : undefined,
          }}
        />
      </div>
      <div className="flex items-center w-full justify-between text-xs text-content-secondary desktop:text-sm">
        <div className="flex items-center gap-2">
          <Digits
            value={bullishPercent}
            unit="%"
            className="text-sm text-content-positive"
          />
          <img
            src={bullishIcon}
            alt={t`Bullish`}
            className="h-6 w-6 rounded-full bg-background-positive"
          />
        </div>
        <div className="flex items-center gap-2">
          <Digits
            value={bearishPercent}
            unit="%"
            className="text-sm text-content-negative"
          />
          <img
            src={bearishIcon}
            alt={t`Bearish`}
            className="h-6 w-6 rounded-full bg-background-negative"
          />
        </div>
      </div>
    </div>
  );
};
